<template>
  <div>
    <BuyerKeys v-if="company.buyer" />
  </div>
</template>

<script>
import { mapState } from 'vuex';
import BuyerKeys from './Buyer/BuyerKeys';

export default {
  name: 'CompanyKeys',
  components: {
    BuyerKeys,
  },
  computed: {
    ...mapState('companies', ['company']),
  },
};
</script>
